import { useNavigate } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Search from "widget/Search"
import Pagenation from "widget/Pagenation";

import TStyle from "shared/style/tableStyle";
import TableLoading from "shared/ui/TableLoading"
import useGetJoinTicketStatus from "entity/ticket/useGetJoinTicketStatus";
import timestampCalculator from "shared/lib/timestampCalculator";

/**
 * @Desc 참가권 현황 Page
 * @Access 없음
 *
 */
const JoinTicketStatus = () => {
  const navigate = useNavigate();
  const [joinTicketStatusList, isLoading] = useGetJoinTicketStatus()

  const sizeList = ["short", "expand", "medium", "expand", "medium", "long"]
  const tableHeadList = [
    { label: "ID", sortKey: "accountid" },
    { label: "이름", sortKey: "accountname" },
    { label: "연락처", sortKey: "accountcontact" },
    { label: "대회명", sortKey: "eventname" },
    { label: "사용 여부", sortKey: "isused" },
    { label: "발급 일자", sortKey: "issuedat" },
  ]

  return (
    <Style.Wrapper>
      <MainHeader>참가권 현황</MainHeader>
      <Search 
        placeholder="연락처 또는 이름을 입력해주세요"
        eventIdxFilter={true}
        isUsedFilter={true}
      />

      <Style.ContainerContent>
        <Style.ContainerStatusDiv>
          <Style.ContainerUsedDiv>
            <h2>전체:</h2>
            <p>{joinTicketStatusList?.data?.total || "-"}</p>
          </Style.ContainerUsedDiv>
        </Style.ContainerStatusDiv>

        <TableLoading isLoading={isLoading}>
          <TStyle.TableDiv>
            <TStyle.TableInner>
              <TStyle.TableRow $title>
                {tableHeadList.map((elem, index) => (
                    <TStyle.Data key={index} $title $size={sizeList[index]}>
                      {elem.label}
                    </TStyle.Data>
                ))}
              </TStyle.TableRow>
              {joinTicketStatusList?.data?.items?.map((seed, index) => (
                <TStyle.TableRow
                  key={index}
                  $odd={index % 2 === 1}
                  onClick={() => navigate(`/user/${seed?.accountid}/detail`)}
                >
                  <TStyle.Data $size={sizeList[0]}>{seed?.accountid}</TStyle.Data>
                  <TStyle.Data $size={sizeList[1]}>{seed?.accountname}</TStyle.Data>
                  <TStyle.Data $size={sizeList[2]}>
                    {seed?.accountcontact}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[3]}>{seed?.eventname}</TStyle.Data>
                  <TStyle.Data $size={sizeList[4]}>{seed?.isused ? "사용" : "미사용"}</TStyle.Data>
                  <TStyle.Data $size={sizeList[5]}>{timestampCalculator(seed?.issuedat)}</TStyle.Data>
                </TStyle.TableRow>
              ))}
            </TStyle.TableInner>
          </TStyle.TableDiv>
        </TableLoading>
      </Style.ContainerContent>

      <Pagenation maxPage={joinTicketStatusList?.data?.max_page} />
    </Style.Wrapper>
  );
};

export default JoinTicketStatus;
